export enum USER_TYPE {
	None = 0,
	Agency = 1,
	Client = 2,
	TempWorker = 3,
	Armado = 100,
}
